import type { Alerta } from '@tms/contratos';
import { RANGO_NIVEL } from '../components/estados';

/** true si el nivel vigente es más grave que el nivel con el que se abrió. Sin `nivelInicial` no se considera escalada. */
export function escalo(a: Alerta): boolean {
  return a.nivelInicial !== null && RANGO_NIVEL[a.nivel] > RANGO_NIVEL[a.nivelInicial];
}

/** Orden de las bandejas: primero las más graves, y dentro del nivel las más recientes. */
export function compararPorNivel(a: Alerta, b: Alerta): number {
  return RANGO_NIVEL[b.nivel] - RANGO_NIVEL[a.nivel] || b.inicio.localeCompare(a.inicio);
}
